<template>
    <div>
        <div class="simple-form flex col-2">
            <div class="form-group">
                <div class="form-label">
                    <label>名称:</label>
                </div>
                <div class="form-value">
                    <span>{{ realCom.name }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>代码:</label>
                </div>
                <div class="form-value">
                    <span>{{ realCom.code }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>会计期间是否开启</label>
                </div>
                <div class="form-value">
                    <span>{{ realCom.fiscalPeriodOpen ? '是' : '否' }}</span>
                </div>
            </div>
        </div>
        <el-table :data="bankList" class="simple-tbl" style="width:100%;">
            <el-table-column align="center" prop="bankName" label="所属银行"></el-table-column>
            <el-table-column align="center" prop="bankCode" label="银行代码" width="100"></el-table-column>
            <el-table-column align="center" prop="cardNo" label="银行卡号" width="160"></el-table-column>
            <el-table-column align="center" prop="acctName" label="银行账号名称" width="120"></el-table-column>
            <el-table-column align="center" prop="acctNo" label="银行账号" width="160"></el-table-column>
            <el-table-column align="center" prop="vfCode" label="打款验证码" width="80"></el-table-column>
            <el-table-column align="center" prop="usage" label="用途" width="60">
                <template slot-scope="rows">
                    <span>{{ bankAcctUsageMap[rows.row.bankAcctUsage] || '' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="defaulted" label="默认" width="60">
                <template slot-scope="rows">
                    <span>{{ rows.row.defaulted ? '是' : '否' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="locked" label="是否锁定" width="60">
                <template slot-scope="rows">
                    <span>{{ rows.row.locked ? '是' : '否' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="frozen" label="是否冻结" width="60">
                <template slot-scope="rows">
                    <span>{{ rows.row.frozen ? '是' : '否' }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { MsgBox } from '../../app.vues'

import merchtComnApi from '../../api/merchtComn'

export default {
    name: 'swb-real-com-info',
    desc: '实体公司详情-实体公司树',
    props: ['id'],
    data: function () {
        return {
            realCom: {},
            bankList: [],
            bankAcctUsageMap: getEnumMap('bankAcctUsage', 'value2text')
        }
    },
    created: function () {
        this.getRealCom();
    },
    methods: {
        getRealCom() {
            let self = this;
            let postData = {};
            postData.id = this.id;
            let theLoading = MsgBox.loading();
            merchtComnApi.getRealCom(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    self.realCom = result.data;
                    //
                    self.getRealComBankAcctList(self.realCom.id);
                } else if(result.type == 'error') {
                    MsgBox.error(result.message, result.errid);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getRealComBankAcctList: function (realComId) {
            let self = this;
            let postData = {
                filterItems: {
                    realComId: realComId
                },
                pagination: {
                    pageSize: 9999,
                    pageNumber: 1
                }
            };
            let loading = MsgBox.loading();
            merchtComnApi.getRealComBankAcctList(postData, function (result) {
                loading.hide();
                if(result.type == 'info') {
                    self.bankList = result.data.rows || [];
                } else if(result.type == 'error') {
                    MsgBox.error(result.message, result.errid);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/RealComInfo.vue